<template>
  <td class="align-middle text-center" :class="getReportProviderStatusColorClass(status)">
    {{ splitCamelCase(status) }}
  </td>
</template>

<script>
import { useReport } from '@/use/report'
import { useHelper } from '@/use/helper'

export default {
  props: {
    status: {
      default: ''
    }
  },
  setup() {
    const { getReportProviderStatusColorClass } = useReport()
    const { splitCamelCase } = useHelper()
    return {
      getReportProviderStatusColorClass,
      splitCamelCase
    }
  }
}
</script>
